import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function loadRailwayStation(data) {
  return request({
    url: URL.mdm.railwayStation.loadRailwayStation,
    method: 'post',
    data
  })
}

export function loadTempalteRailwayStation(data) {
  return request({
    url: URL.mdm.railwayStation.loadTempalteRailwayStation,
    method: 'post',
    data
  })
}

export function getUsedRailwayStations(data) {
  return request({
    url: URL.mdm.railwayStation.getUsedRailwayStations,
    method: 'post',
    data
  })
}

export function deleteRailwayStationsByUUID(data) {
  return request({
    url: URL.mdm.railwayStation.deleteRailwayStationsByUUID,
    method: 'post',
    data
  })
}

export function savePlatformRailwayStation(data) {
  return request({
    url: URL.mdm.railwayStation.savePlatformRailwayStation,
    method: 'post',
    data
  })
}

export function save(data) {
  return request({
    url: URL.mdm.railwayStation.save,
    method: 'post',
    data
  })
}

export function batchSave(data) {
  return request({
    url: URL.mdm.railwayStation.batchSave,
    method: 'post',
    data
  })
}

